// import { get } from 'lodash'
export default function renewalsReducer(
    state: any = {
        renewals: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
            loadMore: false,
        },
        renewAsIs: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        renewPolicy: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        lapseRenewal: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Renewals list reducer
         */
        case 'FETCH_RENEWALS_LIST_PENDING': {
            return { ...state, renewals: { ...state.renewals, loading: true, success: null, loadMore: false } }
        }

        case 'FETCH_RENEWALS_LIST_REJECTED': {
            return {
                ...state, renewals: {
                    ...state.renewals,
                    done: true,
                    loading: false,

                    error: action.payload.error,
                    response: action.payload,
                    success: false,
                    loadMore: false,
                },
            }
        }

        case 'FETCH_RENEWALS_LIST_FULFILLED': {
            return {
                ...state, renewals: {
                    ...state.renewals,
                    loading: false,
                    done: true,
                    error: null,
                    loadMore: false,
                    response: action.payload,
                },
            }
        }

        case 'FETCH_RENEWALS_APPEND_PENDING': {
            return {
                ...state, renewals: {
                    ...state.renewals,
                    loadMore: true,
                },
            }
        }

        case'FETCH_RENEWALS_APPEND_REJECTED': {
            return {
                ...state, renewals: {
                    ...state.renewals,
                    loadMore: false,
                },
            }
        }

        case 'FETCH_RENEWALS_APPEND_FULFILLED': {
            return {
                ...state, renewals: {
                    ...state.renewals,
                    loadMore: false,
                    response: {
                        ...state.renewals.response,
                        list: [
                            ...state.renewals.response.list,
                            ...action.payload.list,
                        ],
                    },
                },
            }
        }

        case 'POLICY_ACTION_AFTER': {
            return {
                ...state,
                renewals: {
                    ...state.renewals,
                    loadMore: false,
                    response: {
                        ...state.renewals.response,
                        list: state.renewals.response.list.filter(d => d.id !== action.meta.id),
                        total: state.renewals.response.total - 1,
                    },
                },
            }
        }

        /**
         *     Renew as is reducer
         */
        case 'FETCH_RENEW_AS_IS_PENDING': {
            return { ...state, renewAsIs: { ...state.renewAsIs, loading: true, success: null } }
        }

        case 'FETCH_RENEW_AS_IS_REJECTED': {
            return {
                ...state, renewAsIs: {
                    ...state.renewAsIs,
                    done: true,
                    loading: false,
                    error: action.payload.error,
                    response: action.payload,
                    success: false,
                },
            }
        }

        case 'FETCH_RENEW_AS_IS_FULFILLED': {
            return {
                ...state, renewAsIs: {
                    ...state.renewAsIs,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload,
                },
            }
        }

        /**
         *     Renew as is renew policy reducer
         */
        case 'FETCH_RENEW_POLICY_PENDING': {
            return { ...state, renewPolicy: { ...state.renewPolicy, loading: true, success: null } }
        }

        case 'FETCH_RENEW_POLICY_REJECTED': {
            return {
                ...state, renewPolicy: {
                    ...state.renewPolicy,
                    done: true,
                    loading: false,
                    error: action.payload.error,
                    response: action.payload,
                    success: false,
                },
            }
        }

        case 'FETCH_RENEW_POLICY_FULFILLED': {
            return {
                ...state, renewPolicy: {
                    ...state.renewPolicy,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload,
                },
            }
        }

        /**
         *     Lapse renewal reducer
         */
        case 'FETCH_LAPSE_RENEWAL_PENDING': {
            return { ...state, lapseRenewal: { ...state.lapseRenewal, loading: true, success: null } }
        }

        case 'FETCH_LAPSE_RENEWAL_REJECTED': {
            return {
                ...state, lapseRenewal: {
                    ...state.lapseRenewal,
                    done: true,
                    loading: false,
                    error: action.payload.error,
                    response: action.payload,
                    success: false,
                },
            }
        }

        case 'FETCH_LAPSE_RENEWAL_FULFILLED': {
            return {
                ...state, lapseRenewal: {
                    ...state.lapseRenewal,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload,
                },
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/renewals.ts